import React from "react";
import { Container, Row, Button } from 'react-bootstrap';
import './BuildProject.css';


import construction from '../assets/construction.svg';
import { ExternalLink } from 'react-external-link';



function BuildProject() {
   
   
    return (
        <Container fluid className="Buildprojectpage">
        
            <Row>
                <center>
                    <img style={{ width: 20 + 'rem' }}
                        className="img-fluid "
                        src={construction}
                        alt="abouturbanImage"
                    />
                    <h1 className="Buildprojectheader" >Under-Maintenance</h1>
                    <p style={{ color: 'whitesmoke' }}>| Sorry it's a little bit dusty here! I'll be back soon |</p>
                    <em style={{ color: 'whitesmoke' }}>for my designs and case studies...</em><br />
                    <ExternalLink href="/">
                        <Button variant="dark behancebtn">Back</Button><br />
                    </ExternalLink>

                </center>

            </Row>

           
        </Container>

    );
}

export default BuildProject;
